import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import ar from "@/i18n/ar.json";
import en from "@/i18n/en.json";

const dictionaries = { ar, en };

const I18nContext = createContext({
  lang: "ar",
  t: (key) => key,
  dict: ar,
});

function getFromPath(obj, path) {
  return path.split(".").reduce((acc, part) => {
    if (acc === undefined || acc === null) return undefined;
    return acc[part];
  }, obj);
}

export function I18nProvider({ children }) {
  const { pathname } = useLocation();

  const lang = useMemo(() => {
    const first = pathname.split("/").filter(Boolean)[0];
    if (first === "en") return "en";
    return "ar";
  }, [pathname]);

  const dict = dictionaries[lang];

  const t = useMemo(() => {
    return (key, fallback) => {
      const value = getFromPath(dict, key);
      if (value === undefined || value === null) return fallback ?? key;
      return value;
    };
  }, [dict]);

  const value = useMemo(() => ({ lang, t, dict }), [lang, t, dict]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function withLang(lang, path = "") {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `/${lang}${clean === "/" ? "" : clean}`;
}
